import { IFabricationOrder } from '../store/ducks/fabrication-orders/types';
import { FABRICATION_ORDER_INITIAL_STATE } from '../store/ducks/fabrication-purchase-order';
import {
  DEFAULT_EXTRA_ITEM,
  getDefaultFabricationProjectItem,
  DEFAULT_WIRE_ITEM,
  EProvideWireQuantityTypes,
  IFabricationPurchaseOrderState,
  EProductType
} from '../store/ducks/fabrication-purchase-order/types';
import { ILongSteelOrderItem } from '../store/ducks/long-steel-shopping-cart/types';

export const getTotalQuantity = (items: ILongSteelOrderItem[]): string => {
  let total = 0;
  items.forEach((item) => {
    if (item.itemSaleInfo?.unityMeasure !== undefined) {
      const measureUnit = item.destinations[0].measureUnits.find(
        (mu) => mu.measure === item.itemSaleInfo.unityMeasure
      );
      const val = measureUnit
        ? Number(item.itemSaleInfo.quantity) *
          parseFloat(measureUnit.convMeasureTo.replace(/,/gi, '.'))
        : 0;
      total = total + val;
    }
  });
  return total.toFixed(3);
};

export const getFabricationPurchaseStateFromFabricationOrder = (
  fabricationOrder: IFabricationOrder
): IFabricationPurchaseOrderState => {
  const {
    contractNumber,
    orderNumber,
    logisticObservation,
    observation,
    productType,
    vehicleTypes,
    itens,
    otherPieces,
    annealedWires,
    tower
  } = fabricationOrder;

  const fabricationPurchaseOrderState: IFabricationPurchaseOrderState = {
    ...FABRICATION_ORDER_INITIAL_STATE,
    constructionIdentification: {
      ...FABRICATION_ORDER_INITIAL_STATE.constructionIdentification,
      comingFromBuyAgain: true,
      contractNumber,
      orderNumber,
      observation: logisticObservation || '',
      towers: tower.split(', ')
    },
    detailingProject: {
      productType:
        productType === EProductType.VERGALHAO_CORTADO_DOBRADO
          ? EProductType.CORTE_E_DOBRA
          : productType,
      vehiclesTypes: vehicleTypes.map((vt) => vt.description),
      itens: itens.length
        ? itens.map((item) => {
            return {
              ...item,
              pavement: '',
              pavements: []
            };
          })
        : [getDefaultFabricationProjectItem()],
      observation: observation || ''
    },
    extraItens: {
      otherPieces: otherPieces.length > 0 ? otherPieces : [DEFAULT_EXTRA_ITEM],
      annealedWires:
        annealedWires.length > 0
          ? annealedWires.map((aw) => {
              return {
                ...aw,
                provideQuantityBy: aw.percentage
                  ? EProvideWireQuantityTypes.PERCENTAGE
                  : EProvideWireQuantityTypes.WEIGHT
              };
            })
          : [DEFAULT_WIRE_ITEM]
    }
  };

  return fabricationPurchaseOrderState;
};

export const normalizeQuantity = (qty?: string) =>
  (typeof qty === 'string' && Number(qty.length ? qty : 1)) || 1;
